import React from 'react';
import {
  FDBodyText,
  FDIcon,
  FDStack,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';

export const ValuePropositions = ({ bulletPoints }) => {
  if (!bulletPoints || bulletPoints.length === 0) {
    return null;
  }
  return (
    <FDStack direction={'column'} spacing={1}>
      {bulletPoints.map(point => (
        <FDStack direction="row" spacing={1} alignItems="center">
          <FDIcon icon="check" color="success" size="sm" />
          <FDBodyText size="sm" value={point} />
        </FDStack>
      ))}
    </FDStack>
  );
};

ValuePropositions.propTypes = {
  bulletPoints: PropTypes.arrayOf(PropTypes.string),
};
